import { createContentMakersAuthService } from '../shared/auth';

// Create singleton instance using the unified auth service
const authService = createContentMakersAuthService();

// Override the clearAuthData method to maintain Redux integration
authService.clearAuthData = function() {
    this.accessToken = null;
    localStorage.removeItem(this.config.storageKey);
    
    if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
    }

    // Trigger logout action in Redux store to ensure proper navigation
    try {
        // Get store instance and dispatch logout
        const { store } = require('../_store');
        const { authActions } = require('../_store/auth.slice');
        store.dispatch(authActions.logout());
    } catch (error) {
        // Fallback: Force redirect if Redux is not available
        console.warn('Could not dispatch logout action, falling back to window navigation');
        if (typeof window !== 'undefined') {
            window.location.href = '/login';
        }
    }
};

// Export the singleton instance
export default authService; 